import { render } from "./TaskPostReview.vue?vue&type=template&id=1d497643&scoped=true"
import script from "./TaskPostReview.vue?vue&type=script&lang=js"
export * from "./TaskPostReview.vue?vue&type=script&lang=js"

import "./TaskPostReview.vue?vue&type=style&index=0&id=1d497643&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d497643"]])

export default __exports__